import React from 'react'
import './Footer.css'
import foot from '/Users/kritikpatni/portfolio-website/src/Assets/Red+3.png'
import Insta from '@iconscout/react-unicons/icons/uil-instagram'
import Github from '@iconscout/react-unicons/icons/uil-github'
import Linkedin from '@iconscout/react-unicons/icons/uil-linkedin'

function Footer() {
  
  
  return (
    <div className='footer'>
      <img src={foot} alt='' style={{width:'100%'}} />
      <div className='f-content'>
        <span>kritikpatni@gmail.com</span>
        <span>+91-8290834349</span>
        <div className='f-icons'>
            <Insta color='white' size='3rem' />
            <Github color='white' size='3rem' />
            <Linkedin color='white' size='3rem' />
        </div>
      </div>
    </div>
  )
}

export default Footer
